import type { Path } from 'react-hook-form';

/** Distributive over Path<T> union so we get a union of matching prefixes, not never */
type PathThatHasPhone<T> = Path<T> extends infer U ? (U extends `${infer P}.phone` ? P : never) : never;
type PathThatHasPhones<T> = Path<T> extends infer U ? (U extends `${infer P}.phones` ? P : never) : never;
export type ClientPhonesFieldPrefix<T> = PathThatHasPhone<T> & PathThatHasPhones<T>;

type PrimaryPhonePath<T> = Extract<Path<T>, `${string}.phone`>;
type PhonesArrayPath<T> = Extract<Path<T>, `${string}.phones`>;
type PhoneItemPath<T> = Extract<Path<T>, `${string}.phones.${number}.phone`>;

export function primaryPhonePath<T>(prefix: ClientPhonesFieldPrefix<T>): PrimaryPhonePath<T> {
  return `${prefix}.phone` as PrimaryPhonePath<T>;
}

export function phonesArrayPath<T>(prefix: ClientPhonesFieldPrefix<T>): PhonesArrayPath<T> {
  return `${prefix}.phones` as PhonesArrayPath<T>;
}

export function phoneItemPath<T>(prefix: ClientPhonesFieldPrefix<T>, index: number): PhoneItemPath<T> {
  return `${prefix}.phones.${index}.phone` as PhoneItemPath<T>;
}